export default {"src":"/_next/static/media/0x52F24a5e03aee338Da5fd9Df68D2b6FAe1178827.954707a7.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};